<script lang="ts">
	import { _, format } from 'svelte-i18n';
	import { Text, Token, Stack } from '@Shelly/shelly-design-system';
	import {
		capFirstChar,
		conditionsFunc,
		makeValueAndUnitsPrimaryAndBold,
	} from 'src/helpers/utilities';
	import type { IAlarmZone } from '../../alarm_object';
	import CustomDynamicInput from 'src/components/CustomDynamicInput.svelte';

	export let alarm_object: IAlarmZone,
		delayArmActionError: string | undefined = '';

	let realArmDelay;
	$: realArmDelay;

	$: delayArmValue = calculateValueForShowing(
		alarm_object._enable_delay,
		alarm_object._meta.enable_delay_units || 'sec',
	);

	function calculateValueForShowing(_value, unit) {
		//if _value is not null, then we calculate the value to show in the input field, otherwise
		// we return/ showing an empty string/ empty field. So when an zero value come
		//the reactivity will be triggered.
		return _value !== null
			? !delayArmActionError
				? _value / (unit === 'sec' ? 1000 : 60000)
				: delayArmValue
			: '';
	}

	function calculateValueForDispatching(_value, unit) {
		if (conditionsFunc(_value)) {
			delayArmActionError = $format('value_must_be_equal_or_greater_than_zero', {
				default: 'Value must be an integer and equal or greater than 0.',
			});
		} else {
			delayArmActionError = '';
		}
		// _value is empty when the user deletes the value in the input field. In this case,
		// we set the delay to null because _enable_delay expect number or null.
		alarm_object._enable_delay =
			_value !== ''
				? unit === 'sec'
					? Math.round(_value * 1000)
					: Math.round(_value * 60000)
				: null;
		alarm_object._meta.enable_delay_units = unit;
	}

	$: {
		delayArmActionError = conditionsFunc(String(delayArmValue))
			? $format('value_must_be_equal_or_greater_than_zero', {
					default: 'Value must be an integer and equal or greater than 0.',
				})
			: undefined;
	}
</script>

<Text element="h2" class="mb-s"
	>{capFirstChar($format('delay_arming', { default: 'Delay arming' }))}</Text
>
<Text styleType="body-small" class="mb-s">
	{@html makeValueAndUnitsPrimaryAndBold(
		`${$format('action_delay_arm_alarm', {
			values: {
				value_and_units: $format(
					`delay_units_${alarm_object._meta.enable_delay_units === 'sec' ? 'seconds' : 'minutes'}`,
					{
						values: { n: delayArmActionError ? 0 : delayArmValue },
					},
				),
			},
		})}`,
	)}
</Text>

<div class="d-flex flex-wrap flex-direction-sm-row flex-direction-md-column">
	<CustomDynamicInput
		additionalContainerClass="d-flex width-md-auto width-sm-full"
		minusFunction={() => {
			calculateValueForDispatching(
				delayArmActionError ? 0 : delayArmValue - 1,
				alarm_object._meta.enable_delay_units,
			);
		}}
		plusFunction={() => {
			calculateValueForDispatching(
				delayArmActionError ? 0 : delayArmValue + 1,
				alarm_object._meta.enable_delay_units,
			);
		}}
		disabledMinusBtn={+delayArmValue <= 0}
		additionalInputAttributes={{
			min: '0',
			max: '1440',
			icon: 'fas fa-clock',
		}}
		bind:error={delayArmActionError}
		bind:value={delayArmValue}
		inputHandler={(e) => {
			realArmDelay = e.target.value;
			calculateValueForDispatching(realArmDelay, alarm_object._meta.enable_delay_units);
		}}
	/>

	<!-- bind:error -->
	<Stack class="ml-sm-0 ml-md-s mt-md-0 mt-sm-s align-self-start" gap="s" direction="column">
		<Token
			id="token-lfbidyo"
			size="m"
			title={capFirstChar($format('select_units_seconds'))}
			selected={alarm_object._meta.enable_delay_units === 'sec'}
			on:click={() =>
				calculateValueForDispatching(delayArmActionError ? realArmDelay : delayArmValue, 'sec')}
		/>

		<Token
			id="token-53r8otp"
			size="m"
			title={capFirstChar($format('select_units_minutes'))}
			selected={alarm_object._meta.enable_delay_units === 'min'}
			on:click={() =>
				calculateValueForDispatching(delayArmActionError ? realArmDelay : delayArmValue, 'min')}
		/>
	</Stack>
</div>
